/* =====================================================================
   UNIVERSEPARFUMS — Header
   - Ouverture / fermeture du drawer mobile
   - Toggle de la barre de recherche desktop
   - Mise à jour du badge panier (écoute "cart:refresh")
   ===================================================================== */
(function () {
  'use strict';

  function init() {
    var header = document.querySelector('[data-up-header]');
    if (!header) return;

    /* ---------- Drawer mobile ---------- */
    var drawer       = header.querySelector('[data-up-drawer]');
    var overlay      = header.querySelector('[data-up-overlay]');
    var openBtn      = header.querySelector('[data-up-drawer-open]');
    var closeBtn     = header.querySelector('[data-up-drawer-close]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) {
        overlay.removeAttribute('hidden');
        // forcer le reflow pour la transition
        // eslint-disable-next-line no-unused-expressions
        overlay.offsetHeight;
        overlay.classList.add('is-open');
      }
      document.body.classList.add('up-drawer-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) {
        overlay.classList.remove('is-open');
        window.setTimeout(function () {
          overlay.setAttribute('hidden', '');
        }, 300);
      }
      document.body.classList.remove('up-drawer-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }

    if (openBtn)  openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);

    /* ---------- Recherche desktop ---------- */
    var searchToggle = header.querySelector('[data-up-search-toggle]');
    var searchPanel  = header.querySelector('[data-up-search]');
    var searchClose  = header.querySelector('[data-up-search-close]');

    function openSearch() {
      if (!searchPanel) return;
      searchPanel.removeAttribute('hidden');
      var input = searchPanel.querySelector('input[type="search"]');
      window.setTimeout(function () {
        if (input) input.focus();
      }, 60);
    }

    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.setAttribute('hidden', '');
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        if (searchPanel.hasAttribute('hidden')) openSearch();
        else closeSearch();
      });
    }
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    /* ---------- Échap ferme tout ---------- */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDrawer();
        closeSearch();
      }
    });

    /* ---------- Mise à jour du compteur panier ---------- */
    var cartCounters = document.querySelectorAll('[data-up-cart-count]');

    function refreshCartCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartCounters.forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-hidden', cart.item_count === 0);
          });
        })
        .catch(function () { /* silent */ });
    }

    // Évènements communs déclenchés par les autres parties du thème
    ['cart:refresh', 'cart:updated', 'ajaxCart.afterCartLoad']
      .forEach(function (evt) {
        document.addEventListener(evt, refreshCartCount);
      });

    /* ---------- Header transparent : bascule au scroll ---------- */
    if (header.dataset.transparent === 'true') {
      var threshold = parseInt(header.dataset.scrollThreshold || '80', 10);
      var ticking = false;

      function updateScrollState() {
        if (window.scrollY > threshold) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(updateScrollState);
          ticking = true;
        }
      }, { passive: true });

      // État initial (au cas où on charge la page déjà scrollée)
      updateScrollState();
    }

    /* ---------- Mesure de la hauteur du header ----------
       Expose --up-header-height à la racine du document pour que d'autres
       sections (hero notamment) puissent s'y adapter avec calc(100vh - var).
       
       Cas particulier : si le header est en mode transparent, il est en
       `position: fixed` et ne prend AUCUNE hauteur dans le flux. On expose
       donc 0 — sinon les sections en dessous laisseraient un blanc de la
       taille du header en bas de leur viewport. */
    function publishHeaderHeight() {
      var isFloating = header.dataset.transparent === 'true';
      var h = isFloating ? 0 : header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--up-header-height', h + 'px');
    }

    publishHeaderHeight();

    // Recalcul sur resize (debounced via rAF)
    var resizeTicking = false;
    window.addEventListener('resize', function () {
      if (!resizeTicking) {
        window.requestAnimationFrame(function () {
          publishHeaderHeight();
          resizeTicking = false;
        });
        resizeTicking = true;
      }
    }, { passive: true });

    // Recalcul si la taille du header change (logo qui charge, fonts, etc.)
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(publishHeaderHeight);
      ro.observe(header);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
